import { redirect } from 'redux-first-router';

import {
  CardDemo,
  CardGroupDemo,
  CenteredIconDemo,
  CenteredPromptDemo,
  CenteringContentChapter,
  ComplexLayoutsChapter,
  CorneringContentChapter,
  DisplayFlexChapter,
  FeatureListDemo,
  FormFooterDemo,
  GalleryDemo,
  HomePage,
  MosaicDemo,
  PhotoDemo,
  PostDemo,
  ReversingDirectionChapter,
  SideBarDemo,
  SiteHeaderDemo,
  SplitContentChapter,
  StepperInputDemo,
  StreamDemo,
  TabsDemo,
  ThanksPage,
  VerticalDirectionChapter,
  WrappingContentChapter,
} from '../../ui/views';

export const routeToPageMap = {};
export const routeToPathMap = {};

export const pages = [
  {
    id: 'HOME',
    name: 'Intro',
    path: '/',
    component: HomePage,
    type: 'section',
  },
  {
    id: 'DISPLAY_FLEX',
    name: 'It begins with "display: flex"',
    path: '/display-flex',
    component: DisplayFlexChapter,
    type: 'group',
  },
  {
    id: 'STEPPER',
    name: 'Stepper input',
    component: StepperInputDemo,
    type: 'page',
    thumbnailClass: 'stepperInputThumbnail',
  },
  {
    id: 'TABS',
    name: 'Tabs',
    component: TabsDemo,
    type: 'page',
    thumbnailClass: 'tabsThumbnail',
  },
  {
    id: 'SPLIT_CONTENT',
    name: 'Splitting things apart',
    component: SplitContentChapter,
    type: 'group',
  },
  {
    id: 'SITE_HEADER',
    name: 'Site header',
    component: SiteHeaderDemo,
    type: 'page',
    thumbnailClass: 'siteHeaderThumbnail',
  },
  {
    id: 'FORM_FOOTER',
    name: 'Form footer',
    component: FormFooterDemo,
    type: 'page',
    thumbnailClass: 'formFooterThumbnail',
  },
  {
    id: 'CHANGE_DIRECTION',
    name: 'Changing direction',
    component: VerticalDirectionChapter,
    type: 'group',
  },
  {
    id: 'SIDE_BAR',
    name: 'Side bar',
    component: SideBarDemo,
    type: 'page',
    thumbnailClass: 'sideBarThumbnail',
  },
  {
    id: 'CENTERING',
    name: 'Stay centered',
    component: CenteringContentChapter,
    type: 'group',
  },
  {
    id: 'CENTERED_PROMPT',
    name: 'Centered prompt',
    component: CenteredPromptDemo,
    type: 'page',
    thumbnailClass: 'centeredPromptThumbnail',
  },
  {
    id: 'CENTERED_ICON',
    name: 'Centered icon',
    component: CenteredIconDemo,
    type: 'page',
    thumbnailClass: 'centeredIconThumbnail',
  },
  {
    id: 'COMPLEX_LAYOUTS',
    name: `Let's get crazy`,
    component: ComplexLayoutsChapter,
    type: 'group',
  },
  {
    id: 'CARD',
    name: 'Card',
    component: CardDemo,
    type: 'page',
    thumbnailClass: 'cardThumbnail',
  },
  {
    id: 'CARD_GROUP',
    name: 'Card group',
    component: CardGroupDemo,
    type: 'page',
    thumbnailClass: 'cardGroupThumbnail',
  },
  {
    id: 'POST',
    name: 'Post',
    component: PostDemo,
    type: 'page',
    thumbnailClass: 'postThumbnail',
  },
  {
    id: 'REVERSING_DIRECTION',
    name: 'Going in reverse',
    component: ReversingDirectionChapter,
    type: 'group',
  },
  {
    id: 'FEATURE_LIST',
    name: 'Feature list',
    component: FeatureListDemo,
    type: 'page',
    thumbnailClass: 'featureListThumbnail',
  },
  {
    id: 'STREAM',
    name: 'Stream',
    component: StreamDemo,
    type: 'page',
    thumbnailClass: 'streamThumbnail',
  },
  {
    id: 'CORNERING_CONTENT',
    name: 'Cornering content',
    component: CorneringContentChapter,
    type: 'group',
  },
  {
    id: 'PHOTO',
    name: 'Photo',
    component: PhotoDemo,
    type: 'page',
    thumbnailClass: 'photoThumbnail',
  },
  {
    id: 'WRAPPING_CONTENT',
    name: 'Wrapping content',
    component: WrappingContentChapter,
    type: 'group',
  },
  {
    id: 'GALLERY',
    name: 'Gallery',
    component: GalleryDemo,
    type: 'page',
    thumbnailClass: 'galleryThumbnail',
  },
  {
    id: 'MOSAIC',
    name: 'Mosaic',
    component: MosaicDemo,
    type: 'page',
    thumbnailClass: 'mosaicThumbnail',
  },
  {
    id: 'THANKS',
    name: 'Thanks',
    component: ThanksPage,
    type: 'section',
  },
];

pages.forEach((page, index) => {
  // Link each page to the previous one and next one for pagination functionality.
  const previousPage = index > 0 ? pages[index - 1] : undefined;
  if (previousPage) {
    page.previousPage = previousPage; // eslint-disable-line no-param-reassign
    previousPage.nextPage = page;
  }

  //  Replaces camel-case with hyphens:
  // e.g. 'Centered prompt' -> 'centered-prompt'
  function toKebabCase(str) {
    return str
      .toLowerCase()
      .replace(/[-]+/g, ' ')
      .replace(/[^\w^\s]+/g, '')
      .replace(/ +/g, ' ')
      .split(' ')
      .join('-');
  }

  if (!page.path) {
    page.path = `/${toKebabCase(page.name)}`; // eslint-disable-line no-param-reassign
  }

  // Build maps. `id` is used to dispatch the action for navigating to this page's route.
  routeToPageMap[page.id] = page;
  routeToPathMap[page.id] = page.path;
});

const redirects = [
  {
    id: 'HOME_REDIRECT',
    path: '/home',
    thunk: dispatch => {
      const action = redirect({ type: 'HOME' });
      dispatch(action);
    },
  },
];

redirects.forEach(page => {
  routeToPathMap[page.id] = page;
});



// WEBPACK FOOTER //
// ./application/store/pages.js